module.exports = __webpack_public_path__ + "img/img01_sp.51e22d67.jpg";